import { render } from "./PrizesComponent.vue?vue&type=template&id=4914dadb"
const script = {}

import "./PrizesComponent.vue?vue&type=style&index=0&id=4914dadb&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__